import React from 'react';
import ziyodulla from '../Images/Ziyodullo.png';


const Baxtiyor = () => {
    return (
        <div style={{color: 'black'}}>
            <div className='container text-start'>
                <div className='row'>
                    <div className='col-10'>
                        <h1 className='text-center'>МАЪЛУМОТНОМА</h1>
                        <h2 className='text-center'>Суяров Зиёдулло Аширович</h2>
                        <p>2021 йил 6 сентябрдан:</p>
                        <p>Чилонзор туман 2-сон касб-ҳунар мактабининг - Ишлаб чиқариш (амалиёт) ишлари буйича директор ўринбосари</p>
                    </div>   
                    <div className='col-2'>
                        <img src={ziyodulla} />
                    </div>    
                </div> 
                <div className='row'>
                    <div className='col'>
                        <p className='h5'>Туғилган йили:</p>
                        <p>03.05.1981</p>
                        <p className='h5'>Миллати:</p>
                        <p>ўзбек</p>
                        <p className='h5'>Маълумоти:</p>
                        <p>олий</p>
                        <p className='h5'>Маълумоти бўйича мутахассислиги:</p>
                        <p className='h5'>Илмий даражаси:</p>
                        <p>йўқ</p>
                        <p className='h5'>Қайси чет тилларини билади:</p>
                        <p>рус тили</p>
                        <p className='h5'>Давлат мукофотлари билан тақдирланганми (қанақа):</p>
                        <p>йўқ</p>
                        <p className='h5'>Халқ депутатлари, республика, вилоят, шаҳар ва туман Кенгаши депутатими ёки бошқа
сайланадиган органларнинг аъзосими (тўлиқ кўрсатилиши лозим)	</p>
                        <p>йўқ</p>
                    </div>
                    <div className='col'>
                    <p className='h5'>Туғилган жойи:</p>
                        <p>Навоий вилояти, Хатирчи тумани</p>
                        <p className='h5'>Партиявийлиги:</p>
                        <p>йўқ</p>
                        <p className='h5'>Тамомлаган:</p>
                        <p>2011 й. Ўзбекистон миллий университети (магстир) (кундузги)</p>
                        <p>ихтиология</p>
                        <p className='h5'>Илмий унвони:</p>
                        <p>йўқ</p>
                        <p className='h5'>Ҳарбий (махсус) унвони:</p>
                        <p>йўқ</p>
                    </div>
                </div>
                <p className='h3'>МЕҲНАТ ФАОЛИЯТИ</p>
                <p>1997-2000 йй. - Хатирчи тумани Ибн-сино жамоа хўжалигининг - ишчиси</p>
                <p>2000-2001 йй. - Хатирчи туманидаги 14-мактабнинг - биялогия фани ўқитувчиси</p>
                <p>2001-2004 йй. - Тошкент юридик техкикуми "Аниқ ва табиий" фанлар кафедрасининг - ўқитувчиси</p>
                <p>2005-2006 йй. - Тошкент шаҳар Учтепа туманидаги 229-мактабнинг - биология ўқитувчиси</p>
                <p>2007-2012 йй. - Сергели енгил саноат ва касб-ҳунар коллежининг - биология фани ўқитувчиси ва лобаранти</p>
                <p>2012-2018 йй. - Тошкент банк ҳисоб-кредит коллежининг - ўқувчилар турар жойи тарбиячиси билогия фани ўқитувчиси ва услубчиси</p>
                <p>2018-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - "Бухгалтерия ҳисоби" бўлими бошлиғи</p>
                <p>2020-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - Кутубхоначи</p>
                <p>2020-2021 йй. - Чилонзор туман 2-сон касб-ҳунар мактабининг - Ички назорат бўлими инспектори</p>
                <p>2021-2021 йй. - Чилонзор туман 2-сон касб-ҳунар мактабининг - Ўқув - методик бўлим бошлиғи</p>
                <p>2021 й. -  ҳ.в.  - Чилонзор туман 2-сон касб-ҳунар мактабининг - Ишлаб чиқариш (амалиёт) ишлари буйича директор ўринбосари</p>
                    <br />
                <p className='h2'>Малумотнома паспорт, диплом ва меҳнат дафтарчасига асосан тўғри ёзилган</p>
                <div className='row'>
                    <div className='col'>
                        <p className='h4'>КҲМ директори:</p>
                        <p className='h4'>Кадрлар бўйича инспектори:</p>
                    </div>
                    <div className='col'>
                        <p className='h4'>  Б.И.Тўйинов</p>
                        <p className='h4'>  Ш.А.Райимқулов  </p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Baxtiyor;